<div class="flex flex-col gap-4 rounded-lg border px-6 py-3" *transloco="let t">
  <div class="flex justify-between">
    <div iInputGroup class="w-82">
      <IIcon name="search" />
      <input
        iInputGroupInput
        [placeholder]="t('dsp-creatives.search_by_name_or_product')"
        size="sm"
        [(ngModel)]="filter"
      />
    </div>
    <div class="flex gap-2">
      @if (selectedCreatives().size > 0) {
        <button
          iButton
          variant="destructive"
          [loading]="isDeletingSelectedCreatives()"
          [disabled]="isReadOnly()"
          (click)="deleteSelectedCreatives()"
        >
          <IIcon name="trash" />
          {{ t("common.delete") }}
        </button>
      }
      <button iButton variant="secondary" (click)="addCreative()" [disabled]="isReadOnly()">
        <IIcon name="plus" />
        {{ t("dsp-creatives.add_a_creative") }}
      </button>
    </div>
  </div>
  <app-dsp-custom-creatives-table [dspCreatives]="strategyCreatives()" [(selectedCreatives)]="selectedCreatives" />
</div>
